import type { IninServer } from '../types';

export class GenesysServerProxy implements IninServer {
  // this method used to transfer history from chatbot to genesys-widget
  sendMessage(message: string, isHtml?: boolean): void {
    let text = this.HTML2String(message);
    text = this.RemoveCommands(text);
    text = this.RemoveUrl(text);
    // get only the latest 1000 characters
    text = text.slice(0, 1000);
    window.ori?.genesysPlugin.command('WebChatService.sendMessage', { message: text });
  }

  private HTML2String(html: string): string {
    const text = html.replace(/<p/gi, '\n<p');
    const tempDivElement = document.createElement('div');
    tempDivElement.innerHTML = text;

    return tempDivElement.textContent || tempDivElement.textContent || '';
  }

  private RemoveCommands(str: string): string {
    // const regEx = /\(#botCommand=.+?\)/gi;
    const regEx = /\|.+\|/gi;

    return str.replace(regEx, '');
  }

  private RemoveUrl(str: string): string {
    const regEx = /\(http.+?\)/gi;

    return str.replace(regEx, '');
  }
}
